import { Avatar, Icon, formatters } from '@app/ui';
import { EmployeeOverview } from '@app/main/api';
import { Typography } from 'antd';
import { ProviderSpecialtyTag, Name } from '@app/main/components';
import classNames from 'classnames';

export interface EmployeeOverviewContentProps {
  employee: EmployeeOverview;
  compact?: boolean;
  className?: string;
}

const { Title } = Typography;

export function EmployeeOverviewContent(props: EmployeeOverviewContentProps) {
  const { employee, compact, className } = props;
  const { avatar, providerInfo, email } = employee;
  const fullName = formatters.name(employee);

  return (
    <div className={classNames('p-3', className)}>
      <div className="flex flex-row gap-4 items-center">
        <div className="self-start">
          <Avatar size={compact ? 60 : 90} alt={fullName} reference={avatar} />
        </div>
        <div className="min-w-0">
          <Title level={5} className="m-0">
            <Name value={employee} />
          </Title>
          {providerInfo?.specialty && (
            <div className="mt-2 mb-1">
              <ProviderSpecialtyTag name={providerInfo?.specialty?.name} />
            </div>
          )}
          {!compact && (
            <a href={`mailto:${email}`} title={email} className="block truncate mt-1">
              <Icon type="email" />
              <span className="ms-2">{email}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
